import React, { useState, useEffect } from 'react';
import UDIRowPopup, { UDIPopupField, UDIAddRowButton, useUDIRowPopup } from './UDIRowPopup.js';

const MedicinalProductSubstancesList = ({
    UDI,
    setUDI,
    initialData = '[]',
    hiddenFieldName = "Form.EUProductUDI.ListOfMedicinalProductSubstancesAssociatedToTheDevice",
    fieldTitle = "List of Medicinal Product Substances Associated to the Device",
    forceIsEditing = null
}) => {
    // Dictionaries
    const substanceTypes = [
        { key: "MEDICINAL_PRODUCT_SUBSTANCE", value: "MEDICINAL PRODUCT" },
        { key: "HUMAN_PRODUCT_SUBSTANCE", value: "HUMAN PRODUCT" },
    ];

    const languages = [
        { key: "en", value: "English" }, { key: "is", value: "Icelandic" },
        { key: "no", value: "Norwegian" }, { key: "tr", value: "Turkish" },
        { key: "bg", value: "Bulgarian" }, { key: "cs", value: "Czech" },
        { key: "da", value: "Danish" }, { key: "de", value: "German" },
        { key: "et", value: "Estonian" }, { key: "el", value: "Greek" },
        { key: "es", value: "Spanish" }, { key: "fr", value: "French" },
        { key: "hr", value: "Croatian" }, { key: "it", value: "Italian" },
        { key: "lv", value: "Latvian" }, { key: "lt", value: "Lithuanian" },
        { key: "hu", value: "Hungarian" }, { key: "mt", value: "Maltese" },
        { key: "nl", value: "Dutch" }, { key: "pl", value: "Polish" },
        { key: "pt", value: "Portuguese" }, { key: "ro", value: "Romanian" },
        { key: "sk", value: "Slovak" }, { key: "sl", value: "Slovenian" },
        { key: "fi", value: "Finnish" }, { key: "sv", value: "Swedish" },
        { key: "ga", value: "Irish" }
    ];

    // State initialization
    const [items, setItems] = useState(() => {
        try {
            return (typeof initialData === 'string' ? JSON.parse(initialData) : initialData) || [];
        } catch {
            return [];
        }
    });

    const initialFormState = {
        Type: { Value: 'MEDICINAL_PRODUCT_SUBSTANCE', Text: 'MEDICINAL PRODUCT' },
        SubstanceName: {
            Value: '',
            Language: { Value: 'en', Text: 'English' }
        },
        INN: ''
    };

    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [formData, setFormData] = useState(initialFormState);
    const [editingIndex, setEditingIndex] = useState(null);

    // Helper: Format Name for display
    const formatSubstanceName = (item) => {
        if (item.SubstanceName?.Value) {
            return `${item.SubstanceName.Language?.Text || ''}: ${item.SubstanceName.Value}`;
        }
        return "";
    };

    // Handlers
    const handleTypeChange = (e) => {
        const value = e.target.value;
        const text = e.target.options[e.target.selectedIndex].text;
        setFormData(prev => ({ ...prev, Type: { Value: value, Text: text } }));
    };

    const handleLanguageChange = (e) => {
        const value = e.target.value;
        const text = e.target.options[e.target.selectedIndex].text;
        setFormData(prev => ({
            ...prev,
            SubstanceName: { ...prev.SubstanceName, Language: { Value: value, Text: text } }
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "SubstanceValue") {
            setFormData(prev => ({
                ...prev,
                SubstanceName: { ...prev.SubstanceName, Value: value }
            }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSave = () => {
        const updatedItems = [...items];
        if (editingIndex !== null) {
            updatedItems[editingIndex] = formData;
        } else {
            updatedItems.push(formData);
        }

        setItems(updatedItems);

        // Context Sync
        setUDI(prevItem => ({
            ...prevItem,
            ListOfMedicinalProductSubstancesAssociatedToTheDevice: updatedItems
        }));

        popup.close();
    };

    const handleEdit = (index) => {
        setFormData(items[index]);
        setEditingIndex(index);
        popup.openEdit();
    };

    const handleRemove = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);
        setItems(updatedItems);

        setUDI(prevItem => ({
            ...prevItem,
            ListOfMedicinalProductSubstancesAssociatedToTheDevice: updatedItems
        }));
        resetForm();
    };

    const resetForm = () => {
        setFormData(initialFormState);
        setEditingIndex(null);
    };

    const popup = useUDIRowPopup(resetForm);




    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditing(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);

    }, [forceIsEditing]);



    // --- Edit View ---
    return (


        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>

                        {isEditing ?

                            <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Substance Type</th>
                                            <th>Name</th>
                                            <th>INN</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index} className={editingIndex === index ? 'udi-complex-field-row-selected' : ''}>
                                                <td>{item.Type?.Text}</td>
                                                <td>{formatSubstanceName(item)}</td>
                                                <td>{item.INN}</td>
                                                <td>
                                                    <button type="button" className="udiEditButton" onClick={() => handleEdit(index)}>
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                    <button type="button" className="udiRemoveButton" onClick={() => handleRemove(index)}>
                                                        <i className="fas fa-times-circle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <UDIAddRowButton label="Add Medicinal Product Substance" onClick={popup.openAdd} />

                                <UDIRowPopup
                                    isOpen={popup.isOpen}
                                    title={editingIndex !== null ? "Edit Medicinal Product Substance" : "Add Medicinal Product Substance"}
                                    saveLabel={editingIndex !== null ? "Save" : "Add"}
                                    onClose={popup.close}
                                    onSave={handleSave}
                                >
                                    <UDIPopupField label="Substance Type">
                                        <select value={formData.Type.Value} onChange={handleTypeChange}>
                                            {substanceTypes.map(s => <option key={s.key} value={s.key}>{s.value}</option>)}
                                        </select>
                                    </UDIPopupField>
                                    <UDIPopupField label="Name of Substance">
                                        <select value={formData.SubstanceName.Language.Value} onChange={handleLanguageChange} style={{ marginBottom: '5px' }}>
                                            {languages.map(l => <option key={l.key} value={l.key}>{l.value}</option>)}
                                        </select>
                                        <input type="text" name="SubstanceValue" value={formData.SubstanceName.Value} onChange={handleInputChange} />
                                    </UDIPopupField>
                                    <UDIPopupField label="INN">
                                        <input type="text" name="INN" value={formData.INN} onChange={handleInputChange} />
                                    </UDIPopupField>
                                </UDIRowPopup>

                                <input type="hidden" name={hiddenFieldName} value={JSON.stringify(items)} />
                            </div>

                            :


                            <>

                                <table className="dataTable" style={{ borderWidth: '1px', width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Substance Type</th>
                                            <th>Name</th>
                                            <th>INN</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.Type?.Text}</td>
                                                <td>{formatSubstanceName(item)}</td>
                                                <td>{item.INN}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/*
						        <input
							        type="button"
							        className="udiActionButton"
							        value="Edit"
							        onClick={() => changeIsEditingField(true)}
						        />
                                */}


                            </>

                        }

                    </div>

                </div>
            </div>
        </div>


    );
};

export default MedicinalProductSubstancesList;